import { createClient } from "graphql-ws";
import { createSubjectHook } from "./utils/observers";
import { IS_LOCAL } from "./server-select";

const [useServerState, setServerState] = createSubjectHook<
  "CONNECTED" | "DISCONNECTED" | undefined
>(undefined);

export { useServerState };

const getOidcAccessToken = (): string | undefined => {
  for (let i = 0; i < sessionStorage.length; ++i) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith("oidc.wp")) {
      const value = sessionStorage.getItem(key);
      if (value) {
        const token = JSON.parse(value).tokens?.accessToken;
        if (token) return token;
      }
    }
  }
  return undefined;
};

export const createWSClient = (apiUrl: string) => {
  const client = createClient({
    url: `${IS_LOCAL ? "ws://" : "wss://"}${apiUrl}`,
    connectionParams: () => {
      const token = getOidcAccessToken();
      return token ? { authorization: `Bearer ${token}` } : {};
    },
    keepAlive: 10_000,
  });

  client.on("connected", () => {
    setServerState("CONNECTED");
  });
  client.on("closed", () => {
    setServerState("DISCONNECTED");
  });

  return client;
};
